import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Row, Col, Card } from 'antd';
import styled from 'styled-components';

const SkeletonWrapper = styled.div`
  background-color: #f0f2f5;
  border-radius: 10px;1
`;

const SkeletonCard = styled(Card)`
  margin-bottom: 16px;
  .ant-card-body {
    padding: 12px;
  }
`;

const SkeletonRow = ({ index }) => (
  <Row gutter={[16, 16]} style={{ marginTop: '16px' }} data-testid={`skeleton-row-${index}`}>
    {Array.from({ length: 8 }).map(() => {
      const uniqueKey = `skeleton-row-${crypto
        .getRandomValues(new Uint32Array(1))[0]
        .toString(36)}`;
      return (
        <Col
          xs={24}
          md={3}
          key={`skeleton-row-${index}-col-${uniqueKey}`}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Skeleton.Input style={{ width: '100%', height: '36px' }} active />
        </Col>
      );
    })}
  </Row>
);

SkeletonRow.propTypes = {
  index: PropTypes.number,
};

const VehicleManagementSkeleton = () => {
  return (
    <SkeletonWrapper>
      {/* Plaka ve Limit Bilgisi */}
      <Row gutter={[16, 16]} data-testid="skeleton-input">
        {['1', '2'].map((_, index) => {
          const providerKey = `provider-${index}`;
          return (
            <Col
              xs={12}
              md={8}
              key={providerKey}
              style={{ display: 'flex', flexDirection: 'column' }}
            >
              <SkeletonCard bordered={false}>
                <Row gutter={[16, 16]} style={{ alignItems: 'center' }}>
                  <Col>
                    <Skeleton.Avatar
                      shape="square"
                      size={64}
                      style={{ borderRadius: '20px' }}
                      active
                    />
                  </Col>
                  <Col style={{ display: 'flex', flexDirection: 'column' }}>
                    <Skeleton.Input
                      style={{
                        width: '160px',
                        height: '36px',
                        marginTop: '8px',
                      }}
                      active
                    />
                  </Col>
                </Row>
              </SkeletonCard>
            </Col>
          );
        })}
      </Row>

      {/* Araç Bilgileri Tablosu*/}
      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <SkeletonCard bordered={false}>
            {Array.from({ length: 14 }).map((_, index) => {
              // `index` parametresi eklendi
              const uniqueKey = `tab2-row-${crypto
                .getRandomValues(new Uint32Array(1))[0]
                .toString(36)}`;
              return <SkeletonRow key={uniqueKey} index={index} />;
            })}
          </SkeletonCard>
        </Col>
      </Row>
    </SkeletonWrapper>
  );
};

export default VehicleManagementSkeleton;
